export default __webpack_public_path__ + "static/media/xp.070672ea.svg";